/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  AlertOutlined,
  BarChartOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  LoginOutlined,
  UserOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles/login.css";

import logoEnh from "../../../components/images/ENH.png";
import { supportContact } from "../../../config/contact";
import { getRouteByGroup } from "../constants/authConstants";
import { loginRequest } from "../services/authService";
import { saveAuthSession } from "../utils/authStorage";
import { getSession, hasSession } from "../../../security/session";

export default function LoginPage() {
  const history = useHistory();
  const mountedRef = React.useRef(true);

  const [details, setDetails] = useState({ username: "", password: "" });
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [keepLogged, setKeepLogged] = useState(false);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (!hasSession()) return;
    const session = getSession();
    history.replace(getRouteByGroup(session.grupo, session.roles));
  }, [history]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submitting) return;

    setSubmitting(true);
    setError(null);

    try {
      const data = await loginRequest({
        username: details.username.trim(),
        password: details.password,
      });

      saveAuthSession({
        token: data.token,
        username: details.username.trim(),
        grupo: data.grupo,
        roles: data.roles,
        permissions: data.permissions,
        is_superuser: data.is_superuser,
        isSuperuser: data.isSuperuser,
        superuser: data.superuser,
        authMode: data.auth_mode,
        remember: keepLogged,
      });

      toast.success(`Bem-vindo(a), ${details.username.trim()}`);
      history.push(getRouteByGroup(data.grupo, data.roles));
    } catch (requestError) {
      const errorMessage = requestError?.message || "Falha no login.";
      if (mountedRef.current) {
        setError(errorMessage);
      }
      toast.error(errorMessage);
    } finally {
      if (mountedRef.current) {
        setSubmitting(false);
      }
    }
  };

  const canSubmit = details.username.trim().length > 0 && details.password.trim().length > 0;

  return (
    <div className="login-screen">
      <div className="login-bg">
        <div className="login-bg-gradient" />
        <div className="login-bg-pattern" />
        <div className="login-orb login-orb-1" />
        <div className="login-orb login-orb-2" />
        <div className="login-orb login-orb-3" />
        <div className="login-orb login-orb-4" />
      </div>

      <ToastContainer position="top-right" autoClose={2200} />

      <div className="login-shell">
        <section className="login-branding">
          <div className="login-branding-content">
            <div className="login-logo-large-wrap">
              <img src={logoEnh} alt="ENH KOGAS" className="login-logo-large" />
            </div>
            <h1>Sistema Pre-pago ENH KOGAS</h1>
            <p>Portal interno da instituicao para gestao de clientes, pagamentos e recargas.</p>

            <div className="login-features">
              <div className="login-feature">
                <UserOutlined />
                <span>Gestao de clientes</span>
              </div>
              <div className="login-feature">
                <BarChartOutlined />
                <span>Relatorios e monitoria</span>
              </div>
              <div className="login-feature">
                <WalletOutlined />
                <span>Controlo de pagamentos pre-pagos</span>
              </div>
              <div className="login-feature">
                <LoginOutlined />
                <span>Recargas, tokens e historico</span>
              </div>
            </div>
          </div>

          <div className="login-branding-footer">
            <p>Portal interno ENH KOGAS - Sistema Pre-pago</p>
          </div>
        </section>

        <section className="login-form-section">
          <div className="login-card">
            <div className="login-form-header">
              <img src={logoEnh} alt="ENH KOGAS" className="login-logo-small" />
              <h2>Bem-vindo de volta</h2>
              <p>Introduza as credenciais para aceder ao portal interno</p>
            </div>

            <form onSubmit={handleSubmit} className={`login-form${submitting ? ' login-form--loading' : ''}`}>
              {error && (
                <div className="login-error">
                  <AlertOutlined />
                  <span>{error}</span>
                </div>
              )}

              <div className="form-group">
                <label htmlFor="username">Utilizador</label>
                <div className="input-shell">
                  <input
                    id="username"
                    type="text"
                    placeholder="Digite o nome do utilizador"
                    value={details.username}
                    disabled={submitting}
                    onChange={(e) => setDetails({ ...details, username: e.target.value })}
                    autoComplete="username"
                    autoFocus
                  />
                </div>
              </div>

              <div className="form-group">
                <div className="form-label-row">
                  <label htmlFor="password">Palavra-passe</label>
                </div>
                <div className="input-shell">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="********"
                    value={details.password}
                    disabled={submitting}
                    onChange={(e) => setDetails({ ...details, password: e.target.value })}
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword((v) => !v)}
                    disabled={submitting}
                    aria-label={showPassword ? "Ocultar palavra-passe" : "Mostrar palavra-passe"}
                  >
                    {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                  </button>
                </div>
              </div>

              <label className="remember-row">
                <input
                  type="checkbox"
                  checked={keepLogged}
                  onChange={(e) => setKeepLogged(e.target.checked)}
                  disabled={submitting}
                />
                <span>Manter sessao iniciada usando cookies neste navegador</span>
              </label>

              {keepLogged && (
                <div className="cookie-consent-note">
                  Ao entrar, autoriza guardar cookies de sessao para manter o login persistente neste dispositivo.
                </div>
              )}

              <button type="submit" className={`btn-login${submitting ? ' is-loading' : ''}`} disabled={!canSubmit || submitting}>
                {submitting ? (
                  <span className="btn-login-inner">
                    <span className="btn-spinner" />
                    <span>A entrar</span>
                  </span>
                ) : 'Entrar'}
              </button>
            </form>

            <div className="login-help">
              <a href={supportContact.whatsappUrl || "#"} target="_blank" rel="noreferrer">
                Precisa de ajuda?
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
